/**
 * Loader that will default to the logo of the company.
 *
 * @param loadingText - Customise the loading message.
 * @param fullScreen - Passing fullscreen will center the loader and use the full height of the screen.
 */

import { Component, Input, OnInit } from '@angular/core';
import { IProfileEntityDetail } from '@boma/supplier-portal/shared/entities';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'boma-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent implements OnInit {
  selectedOrganization: IProfileEntityDetail;
  @Input() loadingText = null;
  @Input() loaded = false;
  @Input() fullScreen = false;
  @Input() showLogo = true;
  @Input() showTip = false;

  // Could be cool if suppliers could add their own loading messages.
  // todo take input for various modules and adjust array to have objects of module so we can have fun arrays for all types else just generic
  loadingMessages = [
    'Inspired by the heartbeats of Africa, we bring you excellence.',
    'Rooted in the traditions of the continent, we reach for the stars.',
    'Guided by the spirit of Ubuntu, we embrace progress and unity.',
    'Like the rhythm of the Savanna, our commitment never stops.',
    'Drawing strength from the diversity of Africa, we thrive.',
    'Our journey is an African tapestry of innovation and growth.',
    'In the heart of Africa, we find inspiration for a brighter future.',
    'Woven from the threads of African culture, our success shines.',
    'With the power of the Sahara wind, we move forward with purpose.',
    'Just as the mighty Kilimanjaro stands tall, so does our dedication.',
  ];

  browserShortcuts = [
    {
      shortcut: 'Ctrl + N',
      description: 'Open a new PRIVATE browser tab and explore safely',
    },
    {
      shortcut: 'Ctrl + T',
      description: 'Open a new browser tab and explore more!',
    },
    {
      shortcut: 'Ctrl + W',
      description: "Close the current tab when you're done with it.",
    },
    {
      shortcut: 'Ctrl + Shift + T',
      description: 'Oops! Reopen that tab you accidentally closed.',
    },
    {
      shortcut: 'Ctrl + Tab',
      description: 'Hop between your open tabs like a pro!',
    },
    {
      shortcut: 'Ctrl + 1-8',
      description: 'Jump directly to your favourite tabs with ease.',
    },
    {
      shortcut: 'Ctrl + 9',
      description: 'Swing back to the last tab in your line-up.',
    },
    {
      shortcut: 'F5 or Ctrl + R',
      description: 'Refresh the page to see the latest updates.',
    },
    {
      shortcut: 'Ctrl + L or F6',
      description: 'Highlight the address bar and type a new web adventure.',
    },
    {
      shortcut: 'Ctrl + D',
      description: 'Bookmark this page for future rendezvous.',
    },
    {
      shortcut: 'Ctrl + Shift + D',
      description: 'Manage your bookmarks and tidy up your collection.',
    },
    {
      shortcut: 'Ctrl + F',
      description: 'Find that hidden treasure on the current page!',
    },
    {
      shortcut: 'Alt + Left Arrow or Alt + Right Arrow',
      description:
        'Navigate backward or forward through your browsing history.',
    },
    {
      shortcut: 'Ctrl + + (Plus) or Ctrl + - (Minus)',
      description: 'Zoom in or out for the perfect view.',
    },
    {
      shortcut: 'Ctrl + 0 (Zero)',
      description: 'Restore the zoom level to default, just like magic.',
    },
    {
      shortcut: 'Spacebar or Page Down',
      description: 'Scroll down a page for more reading pleasure.',
    },
    {
      shortcut: 'Shift + Spacebar or Page Up',
      description: 'Scroll up a page to revisit the past.',
    },
    {
      shortcut: 'Ctrl + Shift + J',
      description: "Open the browser's developer console for some techy fun.",
    },
    {
      shortcut: 'Ctrl + Shift + Delete',
      description:
        'Clear your browsing history, but not your cherished memories.',
    },
  ];

  tip: { shortcut: string; description: string } | null;

  // You can access the descriptions using browserShortcuts[i].description and the shortcuts using browserShortcuts[i].shortcut.

  constructor(private store: Store) {
    this.loadingText = this.loadingText
      ? this.loadingText
      : this.loadingMessages[
          Math.floor(Math.random() * this.loadingMessages.length)
        ];

    //
  }

  ngOnInit(): void {
    this.tip = this.showTip
      ? this.browserShortcuts[
          Math.floor(Math.random() * this.browserShortcuts.length)
        ]
      : null;

    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(
        tap((selectedOrganization: IProfileEntityDetail) => {
          this.selectedOrganization = selectedOrganization;
        })
      )
      .subscribe();
  }
}
